export enum ZIndex {
  HEADER = "100",
  SHARE_BUTTON = "101",
  SIDEBAR = "105",
}
